import styled from 'styled-components';

export const Table = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  background: white;
`;

export const TableContainer = styled(Table)`
  .alef-data-grid__pagination {
    position: sticky;
    bottom: 0;
    background-color: #fff;
  }

  .alef-data-grid table thead {
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 5;
  }
`;
